export default "__VITE_ASSET__d6b37648__"